import { ComponentConstructor, InjectedIntlProps, injectIntl, InjectIntlConfig } from 'react-intl';

function $injectIntl<P>(options?: InjectIntlConfig) {
  return (WrappedComponent: ComponentConstructor<P & InjectedIntlProps>) => {
    return injectIntl(WrappedComponent, options) as any;
  };
}

class ActionCreator<T, P> {
  readonly type: T;
  readonly payload: P;

  constructor(type: T) { this.type = type; }
  create = (payload?: P): ActionCreator<T, P> => ({ type: this.type, payload } as any);
}

export { ActionCreator };
export { $injectIntl as injectIntl };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/redux.ts